import {
  LOAD_PRODUCTS,
  SET_PRODUCTS,
  RESET_PRODUCT_DETAILS,
  LOAD_PRODUCT_DETAILS,
  SET_PRODUCT_DETAILS,
  PRODUCT_NOT_FOUND,
  SET_PRODUCT_VARIANTS,
  SET_VARIANT,
  SET_PRODUCT_VARIANTS_IMAGES,
  SET_VARIANT_DICTIONARY,
  SET_VARIANT_TYPES,
  SET_VARIANT_COLORS,
  UPDATE_VARIANT_COLOR,
  SET_VARIANT_SIZES,
  UPDATE_VARIANT_SIZES,
  SET_DEFAULT_SELECTION,
  LOAD_BUNDLES,
  SET_BUNDLES,
  LOAD_BUNDLE_DETAILS,
  SET_BUNDLE_DETAILS,
  BUNDLE_NOT_FOUND,
  SET_BUNDLE_ITEMS,
  RESET_PRODUCT_STATE
} from '@/state/mutationTypes'
import getProductStoreDefaultState from './productStoreDefaultState'

export default {
  [LOAD_PRODUCTS](state, payload) {
    state.loadProducts = payload
  },
  [SET_PRODUCTS](state, payload) {
    state.productList = payload
  },
  [RESET_PRODUCT_DETAILS](state) {
    state.productDetails = {}
    state.productVariants = []
    state.productVariantsImages = []
    state.variantDictionary = []
    state.variantTypes = []
    state.variantColors = []
    state.variantSizes = []
  },
  [LOAD_PRODUCT_DETAILS](state, payload) {
    state.loadProductDetails = payload
  },
  [SET_PRODUCT_DETAILS](state, payload) {
    state.productDetails = payload
  },
  [PRODUCT_NOT_FOUND](state, payload) {
    state.productNotFound = payload
  },
  [SET_PRODUCT_VARIANTS](state, payload) {
    state.productVariants = payload
  },

  [SET_VARIANT](state, payload) {
    state.variant = payload
  },
  [SET_PRODUCT_VARIANTS_IMAGES](state, payload) {
    let variantImages = []
    payload.map(productVariant => {
      if (productVariant.attributes.images.length) {
        variantImages.push({
          id: productVariant.id,
          images: productVariant.attributes.images,
          spec: productVariant.attributes.spec
        })
      }
    })
    state.productVariantsImages = variantImages
  },
  [SET_VARIANT_DICTIONARY](state, payload) {
    state.variantDictionary = payload
  },
  [SET_VARIANT_TYPES](state, payload) {
    let variantTypes = []
    payload.map(variant => {
      let existTypeAlready = variantTypes.find(
        type => type.type === variant.type
      )
      if (
        !existTypeAlready &&
        variant.type !== null &&
        variant.type !== undefined
      ) {
        variantTypes.push({
          id: variant.id,
          type: variant.type,
          disabled: true
        })
      }
    })
    state.variantTypes = variantTypes
  },
  [SET_VARIANT_COLORS](state, payload) {
    let variantColors = []
    payload.map(data => {
      let existColorAlready = variantColors.find(
        color => color.color === data.color
      )
      if (
        !existColorAlready &&
        data.color !== null &&
        data.color !== undefined
      ) {
        variantColors.push({
          id: data.id,
          hexCode: data.hexCode,
          color: data.color,
          disabled: state.variantTypes.length ? true : false
        })
      }
    })
    state.variantColors = variantColors
  },
  [UPDATE_VARIANT_COLOR](state, payload) {
    state.variantColors = payload
  },
  [SET_VARIANT_SIZES](state, payload) {
    let variantSizes = []
    let sortSizesBy = process.env.VUE_APP_SORT_SIZES
      ? process.env.VUE_APP_SORT_SIZES.split(',')
      : []

    payload.map(data => {
      let existSizeAlready = variantSizes.find(size => size.size === data.size)
      if (!existSizeAlready && data.size !== null && data.size !== undefined) {
        variantSizes.push({
          size: data.size,
          disabled: state.variantColors.length ? true : false
        })
      }
    })

    // sort sizes to display based on env variable process.env.VUE_APP_SORT_SIZES if exist
    if (sortSizesBy.length) {
      let sizesToSort = variantSizes

      let notMatchedSizes = []
      sizesToSort.forEach(notMatch => {
        if (!sortSizesBy.includes(notMatch.size)) {
          notMatchedSizes.push(notMatch)
        }
      })

      variantSizes = []
      sortSizesBy.forEach(sizeSort => {
        let foundSizes = sizesToSort.filter(
          sizesMatch => sizesMatch.size === sizeSort
        )
        if (foundSizes) {
          variantSizes = [...variantSizes, ...foundSizes]
        }
      })

      variantSizes = [...variantSizes, ...notMatchedSizes]
    }

    state.variantSizes = variantSizes
  },
  [UPDATE_VARIANT_SIZES](state, payload) {
    state.variantSizes = payload
  },
  [SET_DEFAULT_SELECTION](state) {
    if (state.variantTypes.length) {
      state.defaultSelection = {
        defaultBy: 'type',
        default: state.variantTypes[0]
      }
    } else if (state.variantColors.length) {
      state.defaultSelection = {
        defaultBy: 'color',
        default: state.variantColors[0]
      }
    } else {
      state.defaultSelection = {
        defaultBy: 'size',
        default: state.variantSizes[0]
      }
    }
  },
  [LOAD_BUNDLES](state, payload) {
    state.loadBundles = payload
  },
  [SET_BUNDLES](state, payload) {
    state.bundlesList = payload
  },
  [LOAD_BUNDLE_DETAILS](state, payload) {
    state.loadBundleDetails = payload
  },
  [SET_BUNDLE_DETAILS](state, payload) {
    state.bundleDetails = payload
  },
  [BUNDLE_NOT_FOUND](state, payload) {
    state.bundleNotFound = payload
  },
  [SET_BUNDLE_ITEMS](state, bundleItems) {
    let colorSizeDictionary = []
    let typesToDisplay = []
    let colorsToDisplay = []
    let sizesToDisplay = []
    let defaultSelectedType = null
    let defaultSelectedColor = null
    let defaultSelectedSize = null
    let sortSizesBy = process.env.VUE_APP_SORT_SIZES
      ? process.env.VUE_APP_SORT_SIZES.split(',')
      : []

    bundleItems.map(bundleItem => {
      colorSizeDictionary = []
      typesToDisplay = []
      colorsToDisplay = []
      sizesToDisplay = []

      bundleItem.productVariants.forEach(variant => {
        colorSizeDictionary.push({
          id: variant.id,
          type: variant.spec.type,
          color: variant.spec.color,
          hexCode: variant.hex_code,
          size: variant.spec.size
        })
      })

      // types to display
      colorSizeDictionary.map(data => {
        let existTypeAlready = typesToDisplay.find(
          type => type.type === data.type
        )
        if (
          !existTypeAlready &&
          data.type !== null &&
          data.type !== undefined
        ) {
          typesToDisplay.push({
            id: data.id,
            type: data.type
          })
        }
      })

      // colors and sizes to display
      colorSizeDictionary.map(data => {
        let existColorAlready = colorsToDisplay.find(
          color => color.color === data.color
        )
        if (
          !existColorAlready &&
          data.color !== null &&
          data.color !== undefined
        ) {
          colorsToDisplay.push({
            id: data.id,
            hexCode: data.hexCode,
            color: data.color
          })
        }
      })

      colorSizeDictionary.map(data => {
        let existSizeAlready = sizesToDisplay.find(
          size => size.size === data.size
        )
        if (
          !existSizeAlready &&
          data.size !== null &&
          data.size !== undefined
        ) {
          sizesToDisplay.push({
            id: data.id,
            size: data.size,
            disabled: false
          })
        }
      })

      // sort sizes to display based on env variable process.env.VUE_APP_SORT_SIZES if exist
      if (sortSizesBy.length) {
        let sizesToSort = sizesToDisplay
        sizesToDisplay = []

        let notMatchedSizes = []
        sizesToSort.forEach(notMatch => {
          if (!sortSizesBy.includes(notMatch.size)) {
            notMatchedSizes.push(notMatch)
          }
        })

        sortSizesBy.forEach(sizeSort => {
          let foundSizes = sizesToSort.filter(
            sizesMatch => sizesMatch.size === sizeSort
          )
          if (foundSizes) {
            sizesToDisplay = [...sizesToDisplay, ...foundSizes]
          }
        })

        sizesToDisplay = [...sizesToDisplay, ...notMatchedSizes]
      }
      // set default selection
      if (typesToDisplay.length) {
        defaultSelectedType = typesToDisplay[0].type

        if (colorsToDisplay.length) {
          // availables colors by type
          let availableColorsByType = colorSizeDictionary.filter(
            variant => variant.type == defaultSelectedType
          )

          if (availableColorsByType.length) {
            defaultSelectedColor = availableColorsByType[0].color
            for (let index = 0; index < colorsToDisplay.length; index++) {
              let foundColor = availableColorsByType.find(
                availableColor =>
                  availableColor.color == colorsToDisplay[index].color
              )
              if (foundColor) {
                colorsToDisplay[index].disabled = false
              } else {
                colorsToDisplay[index].disabled = true
              }
            }

            // available sizes by color
            let availableSizesByColor = colorSizeDictionary.filter(
              variant =>
                variant.color === defaultSelectedColor &&
                variant.type === defaultSelectedType
            )

            if (availableSizesByColor.length) {
              defaultSelectedSize = availableSizesByColor[0].size
              for (let index = 0; index < sizesToDisplay.length; index++) {
                let foundSize = availableSizesByColor.find(
                  availableSize =>
                    availableSize.size == sizesToDisplay[index].size
                )
                if (foundSize) {
                  sizesToDisplay[index].disabled = false
                } else {
                  sizesToDisplay[index].disabled = true
                }
              }
            } else {
              for (let index = 0; index < sizesToDisplay.length; index++) {
                sizesToDisplay[index].disabled = true
              }
            }
          } else {
            for (let index = 0; index < colorsToDisplay.length; index++) {
              colorsToDisplay[index].disabled = true
            }
            defaultSelectedColor = null
            defaultSelectedSize = null
          }
        } else {
          // availables sizes by type
          let availableSizesByType = colorSizeDictionary.filter(
            variant => variant.type == defaultSelectedType
          )

          if (availableSizesByType.length) {
            defaultSelectedColor = null

            if (availableSizesByType.length) {
              defaultSelectedSize = availableSizesByType[0].size
              for (let index = 0; index < sizesToDisplay.length; index++) {
                let foundSize = sizesToDisplay.find(
                  availableSize =>
                    availableSize.size == sizesToDisplay[index].size
                )
                if (foundSize) {
                  sizesToDisplay[index].disabled = false
                } else {
                  sizesToDisplay[index].disabled = true
                }
              }
            }
          } else {
            for (let index = 0; index < sizesToDisplay.length; index++) {
              sizesToDisplay[index].disabled = true
            }
            defaultSelectedColor = null
            defaultSelectedSize = null
          }
        }
      } else if (colorsToDisplay.length) {
        defaultSelectedType = null
        defaultSelectedColor = colorsToDisplay[0].color

        // available sizes by color
        let availableSizesByColor = colorSizeDictionary.filter(
          variant =>
            variant.color === defaultSelectedColor &&
            variant.type === defaultSelectedType &&
            variant.size !== null
        )

        if (availableSizesByColor.length) {
          defaultSelectedSize = availableSizesByColor[0].size
          for (let index = 0; index < sizesToDisplay.length; index++) {
            let foundSize = sizesToDisplay.find(
              availableSize => availableSize.size == sizesToDisplay[index].size
            )
            if (foundSize) {
              sizesToDisplay[index].disabled = false
            } else {
              sizesToDisplay[index].disabled = true
            }
          }
        } else {
          for (let index = 0; index < sizesToDisplay.length; index++) {
            sizesToDisplay[index].disabled = true
          }
          defaultSelectedSize = null
        }
      } else if (sizesToDisplay.length) {
        // there is only sizes to select
        defaultSelectedType = null
        defaultSelectedColor = null
        defaultSelectedSize = sizesToDisplay[0].size
      }

      let foundVariant = []
      foundVariant = colorSizeDictionary.find(
        dictionary =>
          dictionary.type === defaultSelectedType &&
          dictionary.color === defaultSelectedColor &&
          dictionary.size === defaultSelectedSize
      )

      if (foundVariant) {
        let defaultVariantSelected = bundleItem.productVariants.find(
          variant => variant.id === foundVariant.id
        )

        bundleItem.selectedVariant = {
          id: defaultVariantSelected.id,
          name: defaultVariantSelected.product_name,
          displayName: defaultVariantSelected.display_name,
          type: defaultVariantSelected.spec.type,
          size: defaultVariantSelected.spec.size,
          color: defaultVariantSelected.spec.color,
          price: defaultVariantSelected.price,
          imageURL:
            defaultVariantSelected.representative_images.length > 0
              ? defaultVariantSelected.representative_images[0].url
              : null,
          inventoriesCount: defaultVariantSelected.inventories_count
        }

        bundleItem.selectedType = defaultSelectedType
        bundleItem.selectedColor = defaultSelectedColor
        bundleItem.selectedSize = defaultSelectedSize
      }

      bundleItem.colorSizeDictionary = colorSizeDictionary
      bundleItem.typesToDisplay = typesToDisplay
      bundleItem.colorsToDisplay = colorsToDisplay
      bundleItem.sizesToDisplay = sizesToDisplay
    })

    state.bundleItems = bundleItems
  },
  [RESET_PRODUCT_STATE](state) {
    Object.assign(state, getProductStoreDefaultState())
  }
}
